module.exports = __webpack_public_path__ + "static/media/penguin-public-sc.3a0e3adf.jpg";